import './styles.css';
import './i18n/index.ts';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Workbox } from 'workbox-window';

import { App } from './App.tsx';
import { watchViewport } from './lib/viewport.ts';
import { ErrorBoundary } from './ui/ErrorBoundary.tsx';
import { applySavedTheme } from './lib/theme.ts';

applySavedTheme();

// Before the first render, so full-height screens have a height on every browser.
watchViewport();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// The service worker exists only in production builds (scripts/build-sw.mjs).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  const wb = new Workbox('/sw.js');
  // A new release took over: reload once so the screen shows it (a half-filled entry is kept
  // as a draft and comes back).
  wb.addEventListener('controlling', (event) => {
    if (event.isUpdate) window.location.reload();
  });
  void wb.register();
  // Phones keep the app open for days: look for a new release whenever it comes back on screen.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void wb.update();
  });
}
